import PhotoSwipeLightbox from "photoswipe/lightbox";
export default function initGallery() {
  const lightbox = new PhotoSwipeLightbox({
    gallery: ".gallery__grid",
    children: "a",
    showHideAnimationType: "zoom",
    pswpModule: () => import("photoswipe"),
  });
  lightbox.init();
}
